import React, { useEffect, useState, useCallback } from 'react';
import { List, Card, Collapse, Modal, Tabs, Input, Breadcrumb,Button,Layout } from 'antd';
import { SettingFilled, LikeOutlined, CommentOutlined, CalendarOutlined, HomeOutlined, FilePdfOutlined, DownloadOutlined, SettingOutlined } from '@ant-design/icons';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
import { useTranslation } from 'react-i18next';
import * as AntIcons from '@ant-design/icons';

interface HelpCategory {
    helpCategoryId:string;
    helpCategoryName:string;
    helpCategoryDescription: string;
    helpCategoryIcon: string;
    isActive:string;
    createdDate:boolean;
    createdBy:string;
    updatedDate:string;
    updatedBy:string;
}

interface Faq {
    faqId:string;
    faqQuestion:string;
    faqAnswer: string;
    isActive:string;
    createdDate:boolean;
    createdBy:string;
    updatedDate:string;
    updatedBy:string;
    faqShortName:string;
    isShortNameVisible:boolean;
}



const HelpPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [helpCategoryData, setHelpCategoryData] = useState<HelpCategory[]>([]);
  const [faqData, setFaqData] = useState<Faq[]>([]);
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeFaqKey, setActiveFaqKey] = useState<string | undefined>(undefined);
  const { Search } = Input;
  const [searchText, setSearchText] = useState('');
  const [filteredFaqData, setFilteredFaqData] = useState<Faq[]>([]);

  const fetchToken = async () => {
      const res = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0]
      });
      return res.idToken;
    };

 
    useEffect(() => {
      fetchToken();
      getHelpCategoryData();
      getFaqData();
    }, []);

    useEffect(() => {
        if (faqData.length > 0) {
            setActiveFaqKey(faqData[0].faqId);
        }
    }, [faqData]);

    useEffect(() => {
    // Filter FAQ data based on search text
    if (searchText.trim() === '') {
      setFilteredFaqData(faqData);
    } else {
      const lowerSearch = searchText.toLowerCase();
      setFilteredFaqData(
        faqData.filter(
          (faq) =>
            faq.faqQuestion.toLowerCase().includes(lowerSearch) ||
            faq.faqAnswer.toLowerCase().includes(lowerSearch)
        )
      );
    }
  }, [searchText, faqData]);

    const handleCardClick = (helpCategoryId: string) => {
        navigate('/viewhelpdetails', { state: { helpCategoryId: helpCategoryId } });
    };

    const getHelpCategoryData = async () => {
    if (loading) return;
      try {
        setLoading(true);
        const token = await fetchToken();
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/HelpCategory/GetHelpCategoryByHelpData/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
        if (response.status === 200) {
            setHelpCategoryData(response.data);
        }
        else{
            setHelpCategoryData([]);
        }
      }
      catch (error) {
        console.error('Error while getting help category data:', error);
      }
      finally {
        setLoading(false);
      }
    };

    const getFaqData = async () => {
    if (loading) return;
      try {
        setLoading(true);
        const token = await fetchToken();
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Faq/GetAllFaqData/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
        if (response.status === 200) {
            setFaqData(response.data);
        }
        else{
            setFaqData([]);
        }
      }
      catch (error) {
        console.error('Error while getting help category data:', error);
      }
      finally {
        setLoading(false);
      }
    };

    // Helper function to get icon component by name
    const getIconComponent = (iconName: string) => {
    const Icon = (AntIcons as any)[iconName];
    return Icon ? <Icon style={{ color: '#ffffff', fontSize: 16 }} /> : <AntIcons.QuestionOutlined style={{ color: '#ffffff', fontSize: 16 }} />;
    };

    return (
        <Layout style={{ background: '#F9FAFB' }}>
          <AppHeaderHomePageTemplate />
          <div style={{ 
            maxWidth: '100%', 
            margin: '0 auto', 
            padding: '0px',
            backgroundColor: '#',
            minHeight: '100vh',
            width: '62rem'
            }}>
      
        <Breadcrumb 
        style={{ 
            backgroundColor: 'white',
            padding: '20px 20px 10px',
        }}
        >
        <Breadcrumb.Item>
            <Link to="/home">
            <HomeOutlined style={{ marginRight: '5px' }} />
                {t('home')}
            </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{t('help')}</Breadcrumb.Item>
        </Breadcrumb>
        <div style={{ 
            backgroundColor: 'white',
            padding: '0px 20px', fontWeight: '600', font:'roboto', fontSize: '22px', color: '#000000'
        }}>
            {t('help')}
        </div>
        <div style={{ 
            backgroundColor: 'white',
            padding: '5px 20px', fontWeight: '400', font:'roboto', fontSize: '14px',color: '#000000'
        }}>
           {t('help_text')}
        </div>

        {/* Search Data on FAQ */}
        <div style={{ backgroundColor: 'white', padding: '5px 20px 0 20px' }}>
          <Search
            placeholder="Search FAQ..."
            allowClear
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        {/* Help Category */}
        <div style={{ 
            backgroundColor: 'white',
            padding: '20px 20px', font:'roboto', color: '#000000'
        }}>
            <div
                style={{
                display: 'flex',
                gap: '20px',
                flexWrap: 'wrap', // allows cards to wrap on smaller screens
                }}
            >
            {helpCategoryData.map((cat) => (
                <Card
                    key={cat.helpCategoryId}
                    bordered
                    style={{
                    borderColor: '#d9d9d9',
                    borderWidth: 1,
                    borderStyle: 'solid',
                    display: 'flex',
                    alignItems: 'flex-start',
                    padding: 5,
                    maxWidth: 300,
                    minWidth: 260,
                    cursor: 'pointer',
                    }}
                    bodyStyle={{ display: 'flex', gap: 4, padding: 0 }}
                    onClick={() => handleCardClick(cat.helpCategoryId)}
                >
                    <div
                    style={{
                        width: 32,
                        height: 32,
                        backgroundColor: '#8629A4',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                    >
                    {getIconComponent(cat.helpCategoryIcon)}
                    </div>
                    <div style={{ paddingLeft: '10px' }}>
                    <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600, color: '#000' }}>
                        {cat.helpCategoryName}
                    </h3>
                    <p style={{ margin: 0, fontSize: 14, color: '#666' }}>
                        {cat.helpCategoryDescription}
                    </p>
                    </div>
                </Card>
                ))}
            </div>
        </div>

        {/* FAQ Section */}
        <div style={{backgroundColor:'white'}}>
            <div style={{ 
                backgroundColor: 'white',
                padding: '10px 20px', font:'roboto', fontSize: '16px', fontWeight:'600', color: '#000000'
            }}>
                {t('frequently_asked_questions')}
            </div>
            <div>
                {/* FAQ Short Names List */}
                {filteredFaqData.filter(faq => faq.faqShortName && faq.faqShortName.trim() !== '').length > 0 && (
                <div
                    style={{
                    backgroundColor: 'white',
                    padding: '10px 20px',
                    borderRadius: 4,
                    }}
                >
                    <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)', // 4 columns
                        gap: '10px 32px',
                    }}
                    >
                    {filteredFaqData
                        .filter(faq => faq.faqShortName && faq.faqShortName.trim() !== '')
                        .map((faq, idx) => (
                        <div
                            key={faq.faqId}
                                style={{
                                flex: '1 1 200px',
                                minWidth: 200,
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: 10,
                                cursor: 'pointer'
                                }}
                            onClick={() => setActiveFaqKey(faq.faqId)}
                        >
                            <span>
                            <AntIcons.CheckCircleFilled style={{ color: '#1677FF', marginRight: 8 }} />
                            </span>
                            <span style={{ fontSize: 15, color: '#222' }}>{faq.faqShortName}</span>
                        </div>
                        ))}
                    </div>
                </div>
                )}
            </div>
            <div style={{ backgroundColor: 'white', padding: '0 20px 20px 20px', fontWeight:'400' }}>
                <Collapse
                accordion
                activeKey={activeFaqKey}
                onChange={(key) => setActiveFaqKey(key as string)}
                >
                {filteredFaqData.map((faq) => (
                    <Collapse.Panel 
                    header={<span style={{ fontWeight: 'bold', fontSize:'14px' }}>{faq.faqQuestion}</span>} 
                    key={faq.faqId}>
                    <div style={{ fontSize: 14, color: '#000000' }}>
                        {faq.faqAnswer}
                    </div>
                    </Collapse.Panel>
                ))}
                {filteredFaqData.length === 0 && (
                    <Collapse.Panel header="No FAQ found" key="no-faq" disabled />
                )}
                </Collapse>
            </div>
        </div>
    </div>

        </Layout>
      );
    };

export default HelpPage;